import React from 'react';
// import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import { Link } from 'react-router-dom';

const HomeCard = ({service}) => {
     const {img, name, price, description, _id} = service;
     const image = [];
    image.push(img)
    return (
        <div>
        <div className="card card-compact w-96 bg-green-500 text-black shadow-xl mt-10">
  <figure>
    {/* <PhotoProvider> */}
      <div className='foo'>
      {/* {image.map((item, index) => (     */}
        {/* // <PhotoView key={index} src={item}> */}
          <div className="group relative items-center justify-center overflow-hidden cursor-pointer hover:shadow-xl hover:shadow-black/30 transition-shadow">
            {/* <div className="h-96 w-72"> */}
           <img src={img} style={{height:"200px", width:"400px"}} className="w-full h-full object-cover group-hover:rotate-3 group-hover:scale-125 transition:transform duration-500" alt="Shoes" />
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black group-hover:from-black/70 group-hover:via-black/60 group-hover:to-black/70"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center px-9 text-center translate-y-[55%] group-hover:translate-y-0 transition-all">
                <h1 className='text-white'>Name: {name}</h1>
                <p className='text-lg italic text-white mb-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300'>
                {
                     description.length > 100 ? 
                     <>{description.slice(0, 100) + "..."}<Link to={`allServicesDetail/${_id}`}><span className='
                     text-blue-800'>See Details...</span></Link></>
                     :
                      description
                }  
                </p>
            </div>
            </div>
          {/* </div> */}
        {/* </PhotoView> */}
        {/* // ))} */}
      </div>
    {/* </PhotoProvider> */}
  </figure>
  <div className="card-body">
    <div className='flex justify-between items-center'>
    <h2 className="card-title">Name: {name}</h2>
    <h2 className="card-title">Price: ${price}</h2>
    </div>
    {
        description.length > 100 ? 
        <>{description.slice(0, 100) + "..."}<Link to={`allServicesDetail/${_id}`}><span className='
        text-white'>See Details...</span></Link></>
        :
        description
    }  
  </div>
</div> 
        </div>
    );
};

export default HomeCard;